export const BASE_URL= process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080';
//aqui esta dizendo que é para pegar a url que está no netifly se não tiver pega o localhost